/*
 * Ryan O'Dowd
 * 2025-05-22
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import Button from '@components/common/Button';
import Dialog from '@components/common/Dialog';
import DownloadLinks from '@website/components/DownloadLinks';
import {
  FEEDBACK_CHAT_ROUTE,
} from '@utils/store/actions';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const RateDialog = (props: RateDialogProps) => {
  const navigation = hooks.useNavigation();
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  return (
    <Dialog
      visible={true}
      onDismiss={() => props.onClose()}
    >
      <Dialog.Title>{i18n('rateWrinkly')}</Dialog.Title>
      <Dialog.Content>
        <Text style={styles.text}>Positive reviews in the App Store and Play Store are some of the best ways to support Wrinkly.  We appreciate your ratings, and if you have any other feedback, please let us know via <Text style={styles.link} onPress={() => navigation.navigate(FEEDBACK_CHAT_ROUTE)}>Feedback Chat</Text>.  Thanks!</Text>{/* @TODO: i18n */}
        <View style={styles.downloadLinksWrapper}>
          <DownloadLinks hideWeb={true} />
        </View>
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          mode='contained'
          onPress={() => props.onClose()}
        >
          {i18n('close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

class RateDialogProps {
  onClose: () => void;
};

export default RateDialog;
